import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { PermissionResponse } from '@/types/role';

export const permissionsApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<PermissionResponse>>>('/v1/permissions', { params })),
};
